<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">价格维护</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="保存" type="primary" @click="saveData" />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :model="wlyBasePricePo"
        :rules="rules"
        :show-message="false"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="product_id" label="产品ID">
              <wly-input
                v-model="wlyBasePricePo.product_id"
                size="mini"
                :disabled="mode === 'edit'"
                input-type="product"
                @enter="handleEnter"
                @handleSuffixClick="showClient($event, '产品选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="prodcut_desc" label="产品描述">
              <el-input v-model="wlyBasePricePo.prodcut_desc" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="zpric_type" label="价格类型">
              <el-select v-model="wlyBasePricePo.zpric_type" placeholder="请选择" clearable>
                <el-option
                  v-for="item in selectDataOptions['A0020']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="kbetr" label="价格金额">
              <el-input v-model="wlyBasePricePo.kbetr" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="unit" label="产品单位">
              <el-input v-model="wlyBasePricePo.unit" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="kpein" label="金额单位">
              <el-input v-model="wlyBasePricePo.kpein" disabled />
            </el-form-item>
          </el-col>
          <template v-if="kotabnr == 'CUS80100'">
            <el-col :lg="8" :md="12">
              <el-form-item prop="partner" label="客户编号">
                <!-- <el-input
                  v-model="wlyBasePricePo.partner"
                  placeholder="请输入"
                  clearable
                  @focus="showClient($event, '客户选择')"
                /> -->
                <wly-input
                  v-model="wlyBasePricePo.partner"
                  input-type="customer"
                  @enter="handleEnter"
                  @handleSuffixClick="showClient($event, '客户选择')"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item prop="name_org1" label="客户名称">
                <el-input
                  v-model="wlyBasePricePo.name_org1"
                  placeholder="请输入"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
          </template>
          <template v-if="kotabnr != 'CUS80300'">
            <el-col :lg="8" :md="12">
              <el-form-item prop="zzfld00001h" label="营销单元">
                <el-select v-model="wlyBasePricePo.zzfld00001h" :disabled="selectDataOptions['orgList'] && selectDataOptions['orgList'].length < 2" clearable>
                  <el-option
                    v-for="item in selectDataOptions['orgList']"
                    :key="item.zzfld00001h || item.SOBID"
                    :label="item.mc_short || item.MC_SHORT"
                    :value="item.zzfld00001h || item.SOBID"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <el-col :lg="8" :md="12">
            <el-form-item prop="fdate" label="有效日期起">
              <el-date-picker
                v-model="wlyBasePricePo.fdate"
                type="date"
                :disabled="mode === 'edit'"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="tdate" label="有效日期截止">
              <el-date-picker
                v-model="wlyBasePricePo.tdate"
                type="date"
                :disabled="mode === 'edit'"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="remark" label="备注">
            <el-input
              v-model="wlyBasePricePo.remark"
              type="textarea"
              rows="3"
            />
          </el-form-item>
        </el-row>
      </el-form>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      :title="dialogTitle"
      width="70%"
      distory-on-close
    >
      <client-select v-if="dialogTitle === '客户选择'" ref="ClientSelect" />
      <product-select v-if="dialogTitle === '产品选择'" ref="ClientSelect" />
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="confirmClient"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import { apiSapClientFindInfo } from '@/api/common'
import { savePrice, apiGetPriceDetail } from '@/api/sap/client-sap'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import { mapGetters } from 'vuex'

export default {
  name: 'PriceEdit',
  components: { ClientSelect, ProductSelect },

  data() {
    const rules = {
      zpric_type: [{ required: true, message: '请选择价格类型', trigger: 'change' }],
      kbetr: [{ required: true, message: '请输入价格金额', trigger: 'blur' }],
      tdate: [{ required: true, message: '请选择有效日期至', trigger: 'blur' }],
      fdate: [{ required: true, message: '请选择有效日期起', trigger: 'blur' }]
    }
    return {
      rules,
      loading: false,
      showDialog: false,
      dialogTitle: '',
      errorList: [],
      mode: 'edit',
      wlyBasePricePo: {
        product_id: '',
        short_text: '',
        zpric_type: '',
        kbetr: '',
        unit: 'CAR',
        unit_text: '盒',
        prodcut_desc: '',
        kpein: 'CNY',
        zzfld00001h: '',
        partner: '',
        name_org1: '',
        fdate: '',
        remark: '',
        tdate: '99991231'
      },
      kotabnr: '',
      selectDataOptions: {}
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo'])
  },
  created() {
    this.getSelectDictDataOrigin('A0020')
    const { id, kotabnr, type } = this.$route.query
    if (type === 'add') {
      this.mode = type
      this.kotabnr = kotabnr
      if (this.$_has(['WLY023', 'WLY024'])) {
        this.selectDataOptions['orgList'] = this.customerInfo.yxdy
        this.wlyBasePricePo.zzfld00001h = this.customerInfo.yxdy[0].zzfld00001h
      } else {
        this.initSale()
      }
    } else {
      this.kotabnr = kotabnr
      this.queryData(id, kotabnr)
    }
  },
  methods: {
    async initSale() {
      if (this.kotabnr === 'CUS80100') {
        this.initCustome()
      } else if (this.kotabnr === 'CUS80200') {
        const { DATA } = await apiGetOrgOrBase('', 1)
        this.$set(this.selectDataOptions, 'orgList', DATA)
      }
    },
    showClient(e, title) {
      e.target.blur()
      this.dialogTitle = title
      this.showDialog = true
    },
    ClientChange(e) {
      if (!e) {
        this.$set(this.selectDataOptions, 'orgList', [])
        this.wlyBasePricePo.zzfld00001h = ''
      }
    },
    async confirmClient() {
      const data = await this.$refs.ClientSelect.submitForm()
      console.log(data.name_org1)
      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.wlyBasePricePo.name_org1 = data.name_org1
        this.wlyBasePricePo.partner = data.customerCode
        this.wlyBasePricePo.zzfld00001h = data.orgList[0].zzfld00001h
        this.$set(this.selectDataOptions, 'orgList', data.orgList)
      } else {
        this.wlyBasePricePo.product_id = data.PRODUCT_ID
        this.wlyBasePricePo.prodcut_desc = data.SHORT_TEXT
      }
      this.showDialog = false
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        rt_partner: [
          {
            SIGN: 'I',
            OPTION: 'EQ',
            LOW: this.wlyBasePricePo.partner,
            HIGH: ''
          }
        ],
        page: 1,
        pagesize: 50
      }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0]?.yxdy)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async queryData(varnumh, kotabnr) {
      const { data } = await apiGetPriceDetail({ varnumh, kotabnr })
      // const data = JSON.parse(window.localStorage.getItem('price-data'))
      this.wlyBasePricePo = { ...data }
      this.initSale()
    },
    async saveData() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          const params = {
            PRICETYPE: this.kotabnr,
            head: {
              VARNUMH: '',
              ...this.wlyBasePricePo,
              UNIT: this.wlyBasePricePo.UNIT,
              ZZFLD00001H: this.wlyBasePricePo.ZSALESUNIT
            },
            mode: this.mode === 'edit' ? 'U' : 'C'
          }

          this.loading = true
          try {
            // throw new Error('没有测试数据，直接报错！')
            const res = await savePrice(params)
            if (res.MSGTYPE === 'S') {
              this.$message.success(res.MESSAGE)
              if (res.MSGS.length) {
                res.MSGS.forEach(v => {
                  if (v.MSGTYPE === 'W') {
                    setTimeout(() => {
                      this.$message.warning(v.MESSAGE)
                    }, 0)
                  }
                })
              }
            } else {
              this.$message.warning(res.MESSAGE)
            }
          } catch (e) {
            //
          }
          this.loading = false
        } else {
          return false
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data) {
      this.errorList = []
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      if (type === 'product') {
        this.wlyBasePricePo.product_id = data.PRODUCT_ID
        this.wlyBasePricePo.prodcut_desc = data.SHORT_TEXT
      } else {
        this.wlyBasePricePo.name_org1 = data.name_org1
        this.wlyBasePricePo.partner = data.customerCode
        this.wlyBasePricePo.zzfld00001h = data.orgList[0].zzfld00001h
        this.$set(this.selectDataOptions, 'orgList', data.orgList)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 15px 15px;
  text-align: left;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/price-manage/priceEdit.vue